
import * as THREE from 'three';
import Movements from './movement.js';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { DragControls } from 'three/examples/jsm/controls/DragControls.js';
import { gsap } from 'gsap';

// import * as dat from 'dat.gui';

// const gui = new dat.GUI({ width: 360 });

const group = new THREE.Group();

import * as CANNON from 'cannon-es';

const doorUrl = new URL('../public/chair/door.glb', import.meta.url);

const diningUrl = new URL('../public/chair/dining.glb', import.meta.url);
const tableurl = new URL('../public/chair/table.glb', import.meta.url);

const plantUrl = new URL('../public/chair/plant.glb', import.meta.url);

const sofaUrl1 = new URL('../public/chair/sofa_set.glb', import.meta.url);

const remoteurl = new URL('../public/chair/remote.glb', import.meta.url);

const canvas = document.querySelector('canvas.webgl')

const renderer = new THREE.WebGL1Renderer({
    canvas: canvas
});

const scene = new THREE.Scene();
// scene.background = new THREE.Color(0x00BFFF); //#00BFFF
const loader = new THREE.TextureLoader(new THREE.LoadingManager());

const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () => {
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    renderer.setSize(sizes.width, sizes.height)
})

const camera = new THREE.PerspectiveCamera(
    50,
    sizes.width / sizes.height,
    0.1,
    1000
);

renderer.shadowMap.enabled = true
renderer.shadowMap.type = THREE.PCFShadowMap

let cloudParticles = [], flash;

flash = new THREE.PointLight(0x062d89, 30, 500, 1.7);
flash.position.set(200, 300, 100);
scene.add(flash);

renderer.setSize(sizes.width, sizes.height);
renderer.setPixelRatio(window.devicePixelRatio);
document.body.appendChild(renderer.domElement);

renderer.render(scene, camera);
const orbit = new OrbitControls(camera, canvas);
orbit.enableDamping = true;
orbit.enableZoom = true;
orbit.minDistance = 10;
orbit.maxDistance = 44;

// orbit.minPolarAngle = Math.PI * 0.2;
orbit.maxPolarAngle = Math.PI * 0.48;

const amibition_light = new THREE.AmbientLight(0x404040); // 0x404040
scene.add(amibition_light)
const direction_light = new THREE.DirectionalLight(0xffffff, 1);

direction_light.position.set(2, 10, - 3)

scene.add(direction_light)

direction_light.shadow.mapSize.width = 1024;
direction_light.shadow.mapSize.height = 1024;

direction_light.shadow.radius = 10;

direction_light.shadow.camera.near = 2
direction_light.shadow.camera.far = 15

direction_light.castShadow = true;

const directionalLightCameraHelper = new THREE.CameraHelper(direction_light.shadow.camera);
scene.add(directionalLightCameraHelper);
directionalLightCameraHelper.visible = false;

const spotLight = new THREE.SpotLight(0xffffff, 0.5, 40, Math.PI * 0.3);

spotLight.castShadow = true;
spotLight.position.set(-10, 5.5, 0);
scene.add(spotLight)

scene.add(spotLight.target);

spotLight.target.position.x = -10;

spotLight.castShadow = true;

spotLight.shadow.camera.near = 1;
spotLight.shadow.camera.far = 10;

const spotLightCameraHelper = new THREE.CameraHelper(spotLight.shadow.camera);
spotLightCameraHelper.visible = true;
// scene.add(spotLightCameraHelper);

// ********************** starting html contant **************

let sceneReady = false;

const newPoints = [
    {
        position: new THREE.Vector3(-2.5, 4, 2.2),
        element: document.querySelector('.point-0')
    },
    {
        position: new THREE.Vector3(-8, 5, -4.5),
        element: document.querySelector('.point-1')
    },
    {
        position: new THREE.Vector3(-5.5, 2.9, 30),
        element: document.querySelector('.point-2')
    },
    {
        position: new THREE.Vector3(-15, 5, 1),
        element: document.querySelector('.point-3')
    },
    {
        position: new THREE.Vector3(4, 5.5, 17),
        element: document.querySelector('.point-4')
    },
    {
        position: new THREE.Vector3(3, 1.5, 23),
        element: document.querySelector('.point-5')
    }
    
    
]

// ******************** ending html contant **************

var operation = document.getElementById("inside0");

operation.addEventListener("click", onMouseClick);

var operation1 = document.getElementById("inside1");

operation1.addEventListener("click", onMouseClick);

var operation2 = document.getElementById("inside2");

operation2.addEventListener("click", onMouseClick);

var operation3 = document.getElementById("inside3");

operation3.addEventListener("click", onMouseClick);

var operation4 = document.getElementById("inside4");

operation4.addEventListener("click", onMouseClick);

var operation5 = document.getElementById("inside5");

operation5.addEventListener("click", onMouseClick);

// *************************** camerarenderstart **********************

// renderer.domElement.addEventListener('dblclick', onMouseClick, false);

function onMouseClick(event) {

    var mouse = new THREE.Vector2();
    mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
    mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

    var raynewcaster = new THREE.Raycaster();
    raynewcaster.setFromCamera(mouse, camera);

    var intersectss = raynewcaster.intersectObjects(scene.children);

    if (intersectss.length > 0) {

        // camera.position.copy(intersectss[0].point);

        const targetPosition = intersectss[0].point;

        targetPosition.y += 4;
        targetPosition.z += 4;

        animateCubeToPosition(targetPosition);

    }
}

function animateCubeToPosition(targetPosition, duration = 1000) {
    const initialPosition = camera.position.clone();
    let startTime = null;

    function update(time) {
        if (!startTime) startTime = time;
        const elapsedTime = time - startTime;
        const t = Math.min(elapsedTime / duration, 1);

        const newPosition = initialPosition.clone().lerp(targetPosition, t);
        camera.position.copy(newPosition);

        if (t < 1) {
            requestAnimationFrame(update);
        }
    }
    requestAnimationFrame(update);
}

// renderer.domElement.removeEventListener('click', onMouseClick, false);

// renderer.domElement.addEventListener('dblclick', function(){
//     renderer.domElement.removeEventListener('click', onMouseClick);
// })

// *********************** camerarenderend ******************

const pointLight = new THREE.PointLight(0x00ff00, 0.3);
pointLight.castShadow = true;
pointLight.position.set(-8, 6, 0);
pointLight.shadow.camera.far = 6;
pointLight.shadow.camera.near = 1;
// scene.add(pointLight);
const pointLightCameraHelper = new THREE.CameraHelper(pointLight.shadow.camera);
scene.add(pointLightCameraHelper);
pointLightCameraHelper.visible = false;

const textureLoader = new THREE.TextureLoader();

// ********************** starting shaders ***********************

const flagTexture = textureLoader.load('https://media.istockphoto.com/id/183808106/photo/pool-water-texture-background.jpg?s=170667a&w=0&k=20&c=oqfvT0aetmR3auD2x4IPomB7zGfaMKFwad4OogOjcW0=');

const geometryShaders = new THREE.PlaneGeometry(1, 1, 32, 32);
const count = geometryShaders.attributes.position.count
const randoms = new Float32Array(count);

for (let i = 0; i < count; i++) {
    randoms[i] = Math.random();
}

geometryShaders.setAttribute('aRandom', new THREE.BufferAttribute(randoms, 1));

const materialShaders = new THREE.ShaderMaterial({

    vertexShader: vertex,
    fragmentShader: fragmentShader,
    side: THREE.DoubleSide,
    // transparent: true,

    uniforms:
    {

        uFrequency: { value: new THREE.Vector2(2, 5) },
        uTime: { value: 0 },
        uColor: { value: new THREE.Color('orange') },
        uTexture: { value: flagTexture },

    }
})

const meshshaders = new THREE.Mesh(geometryShaders, materialShaders)
meshshaders.scale.set(25 / 2, 8, 0)
meshshaders.position.set(-8, 2.5, 28);
meshshaders.rotation.x = 4.7;
scene.add(meshshaders)

const swimmingGeoemtry = new THREE.BoxGeometry(12, 2.5, 0.4);
const swimmingMaterial = new THREE.MeshBasicMaterial({ color: '0x00ff00' });
const swimmingMesh = new THREE.Mesh(swimmingGeoemtry, swimmingMaterial);
scene.add(swimmingMesh);
swimmingMesh.position.set(-8, 1.5, 24);

const swimmingGeoemtry1 = new THREE.BoxGeometry(0.3, 2.5, 8);
const swimmingMaterial1 = new THREE.MeshBasicMaterial({ color: '0x00ff00' });
const swimmingMesh1 = new THREE.Mesh(swimmingGeoemtry1, swimmingMaterial1);
scene.add(swimmingMesh1);
swimmingMesh1.position.set(-14.2, 1.5, 28);

const swimmingGeoemtry2 = new THREE.BoxGeometry(0.3, 2.5, 8)
const swimmingMaterial2 = new THREE.MeshBasicMaterial({ color: '0x00ff00' });
const swimmingMesh2 = new THREE.Mesh(swimmingGeoemtry2, swimmingMaterial2);
scene.add(swimmingMesh2);
swimmingMesh2.position.set(-1.9, 1.5, 28);

const swimmingGeoemtry3 = new THREE.BoxGeometry(12, 2.5, 0.4);
const swimmingMaterial3 = new THREE.MeshBasicMaterial({ color: '0x00ff00' });
const swimmingMesh3 = new THREE.Mesh(swimmingGeoemtry3, swimmingMaterial3);
scene.add(swimmingMesh3);
swimmingMesh3.position.set(-8, 1.5, 32);

// ******************** ending shaders ********************

// ***************** starting cutrain *******************

const cutrainTexture = textureLoader.load('https://thumbs.dreamstime.com/b/red-curtain-939957.jpg');

const cutrainShaders = new THREE.PlaneGeometry(3, 8, 32, 32);
const counting = geometryShaders.attributes.position.count
const randomsvalue = new Float32Array(counting);

for (let i = 0; i < counting; i++) {
    randomsvalue[i] = Math.random();
}

geometryShaders.setAttribute('aRandom', new THREE.BufferAttribute(randomsvalue, 1));

const cutrainmaterialShaders = new THREE.ShaderMaterial({

    vertexShader: vertex,
    fragmentShader: fragmentShader,
    side: THREE.DoubleSide,
    // transparent: true,

    uniforms:
    {

        uFrequency: { value: new THREE.Vector2(10, 0) },
        uTime: { value: 0 },
        uColor: { value: new THREE.Color('orange') },
        uTexture: { value: cutrainTexture },

    }
})

const cutrainmeshshaders = new THREE.Mesh(cutrainShaders, cutrainmaterialShaders)
// cutrainmeshshaders.scale.set(25/2,2/3,0)
cutrainmeshshaders.scale.y = 2 / 4;  // 2/3
cutrainmeshshaders.position.set(-7.8, 3.2, -5.4);

scene.add(cutrainmeshshaders)

// *************************** second **********************

const cutrainShaders2 = new THREE.PlaneGeometry(3, 8, 32, 32);
const counting2 = geometryShaders.attributes.position.count
const randomsvalue2 = new Float32Array(counting2);

for (let i = 0; i < counting; i++) {
    randomsvalue2[i] = Math.random();
}

geometryShaders.setAttribute('aRandom', new THREE.BufferAttribute(randomsvalue2, 1));

const cutrainmaterialShaders2 = new THREE.ShaderMaterial({

    vertexShader: vertex,
    fragmentShader: fragmentShader,
    side: THREE.DoubleSide,
    // transparent: true,

    uniforms:
    {
        uFrequency: { value: new THREE.Vector2(10, 0) },
        uTime: { value: 0 },
        uColor: { value: new THREE.Color('orange') },
        uTexture: { value: cutrainTexture },
    }
})

const cutrainmeshshaders2 = new THREE.Mesh(cutrainShaders2, cutrainmaterialShaders2)
// cutrainmeshshaders.scale.set(25/2,2/3,0)     
cutrainmeshshaders2.scale.y = 2 / 4;
cutrainmeshshaders2.position.set(-13, 3.2, -5.4);

scene.add(cutrainmeshshaders2)

// ***************** ending cutrain *************

// *********************** starting shaders pattern ************

const geometryPattern = new THREE.PlaneGeometry(17.2, 5, 32, 32)

// Material
const materialPattern = new THREE.ShaderMaterial({
    vertexShader: testVertexShader,
    fragmentShader: testFragmentShader,
    side: THREE.DoubleSide,
    transparent: true
})

materialPattern.transparent = true;
materialPattern.opacity = 200;

// Mesh
const meshShadersPattern = new THREE.Mesh(geometryPattern, materialPattern);
meshShadersPattern.position.set(12.8, 3.4, 17.8);
// scene.add(meshShadersPattern)

// ********************* ending shaders pattern ************

// *********************** starting loading manager **********

const loadingBarElement = document.querySelector('.loading-bar');

const loadingManager = new THREE.LoadingManager(
    // Loaded
    () => {

        gsap.delayedCall(0.5, () => {
            gsap.to(overlayMaterial.uniforms.uAlpha, { duration: 3, value: 0 });
            loadingBarElement.classList.add('ended');
            loadingBarElement.style.transform = ''
        })
    },

    // Process
    (itemUrl, itemsLoaded, itemsTotal) => {
        const progressRation = itemsLoaded / itemsTotal;
        loadingBarElement.style.transform = `scaleX(${progressRation})`

    },

    window.setTimeout(() => {
        sceneReady = true;
    }, 4000)

);

const overlayGeometry = new THREE.PlaneBufferGeometry(2, 2, 1, 1);
const overlayMaterial = new THREE.ShaderMaterial({
    transparent: true,
    uniforms:
    {
        uAlpha: { value: 1 }
    },
    vertexShader: `
        void main()
        {
            gl_Position =  vec4(position, 1.0);
        }
    `,
    fragmentShader: `
        uniform float uAlpha;

        void main()
        {
            gl_FragColor = vec4(0.0, 0.0, 0.0, uAlpha);
        }
    `
});
const overlay = new THREE.Mesh(overlayGeometry, overlayMaterial);
scene.add(overlay);

// ************************ ending loading manager *********

for (let i = 0; i < 40; i++) {

    const particlesGeometry = new THREE.BoxGeometry(1, 1, 0.05);
    const particlesMaterial = new THREE.PointsMaterial({ color: 'pink' }); //  map: loader.load('../textures/particles/1.png')
    particlesMaterial.size = 0.5;
    particlesMaterial.sizeAttenuation = true;
    particlesMaterial.color = new THREE.Color('#ff88cc');
    // particlesMaterial.map = particleTexture

    const particles = new THREE.Points(particlesGeometry, particlesMaterial);
    scene.add(particles);

    particles.position.x = Math.random();
    particles.position.y = Math.random();
    // particles.position.y = 1;

    group.add(particles)

    scene.add(group);

    group.position.set(0, 2.5, 17.70);

    group.scale.set(6, 2, 0.5);

}

// ****************************Area of Land************************

// **************************** whatever *********************************

const world = new CANNON.World({
    gravity: new CANNON.Vec3(0, -9.81, 0) // -9.81 // 400.81
});

world.broadphase = new CANNON.NaiveBroadphase();

// ***********************FirstFlore************************

const geometry_FirstFlore = new THREE.BoxGeometry(40, 0.15, 30); // 10, 0.15, 3
const material_FirstFlore = new THREE.MeshStandardMaterial({ map: loader.load('https://images.unsplash.com/photo-1515895309288-a3815ab7cf81?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8Zmxvb3IlMjB0ZXh0dXJlfGVufDB8fDB8fA%3D%3D&w=1000&q=80') });
const cube_FirstFlore = new THREE.Mesh(geometry_FirstFlore, material_FirstFlore);
scene.add(cube_FirstFlore);
cube_FirstFlore.position.x = 3;
cube_FirstFlore.position.y = 0.9;
cube_FirstFlore.position.z = 5;

cube_FirstFlore.receiveShadow = true;

import groundImage from '../public/textures/texture.png';

const geometryGround = new THREE.BoxGeometry(80, 0.2, 80);
const materialGround = new THREE.MeshBasicMaterial({ map: loader.load(groundImage) });
const planeGround = new THREE.Mesh(geometryGround, materialGround);
scene.add(planeGround);

planeGround.position.set(0, 0.7, 0);

// group.add(cube_FirstFlore);

cube_FirstFlore.userData.ground = true;

const groundBody = new CANNON.Body({
    shape: new CANNON.Box(new CANNON.Vec3(20, 0.1, 15)),
    // mass: 10
    type: CANNON.Body.STATIC,
    position: new CANNON.Vec3(3, 0.9, 4)
});

world.addBody(groundBody);

// groundBody.quaternion.setFromEuler(-Math.PI / 2, 0, 0);

const timeStep = 1 / 60;

// *****************FrontSideWall*****************************

const geometry_wall = new THREE.BoxGeometry(25.5, 5, 0.4);
const material_wall = new THREE.MeshPhongMaterial({ color: 0x003151 }); // 0x003151
const cube_wall = new THREE.Mesh(geometry_wall, material_wall);
scene.add(cube_wall);
cube_wall.position.x = -2.8;
cube_wall.position.y = 3.4;
cube_wall.position.z = 18;

var raycaster4 = new THREE.Raycaster();
var objects = [cube_wall];

function handleCollision() {
    // Disable OrbitControls when collision occurs
    orbit.enabled = false;

    // Optional: Adjust camera position to avoid collision
    // camera.position.z -= 0.5;
}

function detectCollisions() {
    raycaster4.setFromCamera(new THREE.Vector2(), camera);
    var intersects = raycaster4.intersectObjects(objects);

    if (intersects.length > 0) {
        handleCollision();
    }
}

// group.add(cube_wall);

// ****************leftSidewall*****************************

const geometry_leftSideWall = new THREE.BoxGeometry(0.35, 5, 24);
const material_leftSideWall = new THREE.MeshPhongMaterial({ color: 0x003151 });
const cube_leftSideWall = new THREE.Mesh(geometry_leftSideWall, material_leftSideWall);
scene.add(cube_leftSideWall);
cube_leftSideWall.position.x = -15.4;
cube_leftSideWall.position.y = 3.4;
cube_leftSideWall.position.z = 6;

// group.add(cube_leftSideWall);

// const orbit1 = new OrbitControls(cube_leftSideWall, renderer.domElement);
// orbit1.update();

// ***************left2SideWall************************

const geometry_leftSideWall2 = new THREE.BoxGeometry(0.35, 5, 14);
const material_leftSideWall2 = new THREE.MeshPhongMaterial({ color: 0x708090 });
const cube_leftSideWall2 = new THREE.Mesh(geometry_leftSideWall2, material_leftSideWall2);
scene.add(cube_leftSideWall2);
cube_leftSideWall2.position.set(-5.4, 3.4, -2);

// group.add(cube_leftSideWall2);

const cube_leftSideWall2physics = new CANNON.Body({
    shape: new CANNON.Box(new CANNON.Vec3(0.17, 2.5, 7)),
    // mass: 10
    type: CANNON.Body.DYNAMIC,
    position: new CANNON.Vec3(-5.4, 3.4, -2)

});

world.addBody(cube_leftSideWall2physics);

const geometry_tiles3 = new THREE.BoxGeometry(0.10, 5, 10.5);
const material_tiles3 = new THREE.MeshBasicMaterial({ map: loader.load('https://t4.ftcdn.net/jpg/01/29/36/83/360_F_129368372_Lolknh3EsxTC9Y6ehEfKvWD60FAOx6w8.jpg') }); //https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSM3PtgtmI6lxwYsCQ43kgw5fR0XIRnrjZxujUChxBDiK6p1Lr4ypmgWGqdk98cqBlvw3s&usqp=CAU
const toilettiles3 = new THREE.Mesh(geometry_tiles3, material_tiles3);
scene.add(toilettiles3);
toilettiles3.position.x = -5.25;
toilettiles3.position.y = 3.4;
toilettiles3.position.z = -3.54;

// group.add(toilettiles3);

// ******************BackSideWall********************

const geometry_BackSideWall = new THREE.BoxGeometry(10, 1.5, 0.4);
const material_BackSideWall = new THREE.MeshPhongMaterial({ color: 0x003151 });
const cube_BackSideWall = new THREE.Mesh(geometry_BackSideWall, material_BackSideWall);
scene.add(cube_BackSideWall);
cube_BackSideWall.position.x = -10.5;
cube_BackSideWall.position.y = 1.6;
cube_BackSideWall.position.z = -6;

// group.add(cube_BackSideWall);

// ********************BackSideWallupper******************

const geometry_BackSideWallUpper = new THREE.BoxGeometry(10, 1.5, 0.4);
const material_BackSideWallUpper = new THREE.MeshPhongMaterial({ color: 0x003151 });
const cube_BackSideWallUpper = new THREE.Mesh(geometry_BackSideWallUpper, material_BackSideWallUpper);
scene.add(cube_BackSideWallUpper);
cube_BackSideWallUpper.position.x = -10.5;
cube_BackSideWallUpper.position.y = 5.1;
cube_BackSideWallUpper.position.z = -6;

// group.add(cube_BackSideWallUpper);

// ********************BackSideWallMiddle**********************

const geometry_BackSideWallMiddle = new THREE.BoxGeometry(10, 1.9, 0.4);
const material_BackSideWallMiddle = new THREE.MeshBasicMaterial({ color: 0xffffff });
material_BackSideWallMiddle.transparent = true;
material_BackSideWallMiddle.opacity = 0.1;
const cube_BackSideWallMiddle = new THREE.Mesh(geometry_BackSideWallMiddle, material_BackSideWallMiddle);
scene.add(cube_BackSideWallMiddle);
cube_BackSideWallMiddle.position.x = -10.5;
cube_BackSideWallMiddle.position.y = 3.3;
cube_BackSideWallMiddle.position.z = -6;

// group.add(cube_BackSideWallMiddle);

// ******************HallWall***********************

const geometry_HallWall = new THREE.BoxGeometry(6, 5, 0.4);
const material_HallWall = new THREE.MeshPhongMaterial({ color: 0xff8090 });
const cube_HallWall = new THREE.Mesh(geometry_HallWall, material_HallWall);
scene.add(cube_HallWall);
cube_HallWall.position.x = 1;
cube_HallWall.position.y = 3.4;
cube_HallWall.position.z = 1.8;

cube_HallWall.castShadow = true;
cube_HallWall.addEventListener('click', function (event) {
    console.log("ronak pata nahi kaha raheta hai");
})

// group.add(cube_HallWall);

const geometry_tiles2 = new THREE.BoxGeometry(6, 5, 0.1);
const material_tiles2 = new THREE.MeshBasicMaterial({ map: loader.load('https://t4.ftcdn.net/jpg/01/29/36/83/360_F_129368372_Lolknh3EsxTC9Y6ehEfKvWD60FAOx6w8.jpg') }); //https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSM3PtgtmI6lxwYsCQ43kgw5fR0XIRnrjZxujUChxBDiK6p1Lr4ypmgWGqdk98cqBlvw3s&usqp=CAU
const toilettiles1 = new THREE.Mesh(geometry_tiles2, material_tiles2);
scene.add(toilettiles1);
toilettiles1.position.x = 1;
toilettiles1.position.y = 3.4;
toilettiles1.position.z = 1.6;

// group.add(toilettiles1);

// ******************Halltelevision********************

// *************************WashRoomwall**************************

const geometry_washRoomwall = new THREE.BoxGeometry(0.35, 5, 11);
const material_washRoomwall = new THREE.MeshPhongMaterial({ color: 0x003151 });
const cube_washRoomwall = new THREE.Mesh(geometry_washRoomwall, material_washRoomwall);
scene.add(cube_washRoomwall);
cube_washRoomwall.position.x = 3.8;
cube_washRoomwall.position.y = 3.4;
cube_washRoomwall.position.z = -3.9;

// group.add(cube_washRoomwall);

const geometry_tiles1 = new THREE.BoxGeometry(0.1, 5, 10.5);
const material_tiles1 = new THREE.MeshBasicMaterial({ map: loader.load('https://t4.ftcdn.net/jpg/01/29/36/83/360_F_129368372_Lolknh3EsxTC9Y6ehEfKvWD60FAOx6w8.jpg') }); //https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSM3PtgtmI6lxwYsCQ43kgw5fR0XIRnrjZxujUChxBDiK6p1Lr4ypmgWGqdk98cqBlvw3s&usqp=CAU
const toilettiles = new THREE.Mesh(geometry_tiles1, material_tiles1);
scene.add(toilettiles);
toilettiles.position.x = 3.6;
toilettiles.position.y = 3.4;
toilettiles.position.z = -3.6;

// group.add(toilettiles);

const geometry_tiles4 = new THREE.BoxGeometry(0.1, 5, 10.5);
const material_tiles4 = new THREE.MeshBasicMaterial(); //https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSM3PtgtmI6lxwYsCQ43kgw5fR0XIRnrjZxujUChxBDiK6p1Lr4ypmgWGqdk98cqBlvw3s&usqp=CAU
var texture = loader.load('https://5.imimg.com/data5/EV/XA/AI/SELLER-11714557/153-hl-2-1000x1000.jpg');
texture.repeat.set(4, 2); // Repeat 4 times in the X direction, and 1 time in the Y direction
texture.wrapS = THREE.RepeatWrapping; // Wrap the texture in the X direction
texture.wrapT = THREE.RepeatWrapping; // Wrap the texture in the Y direction
material_tiles4.map = texture;
const toilettiles4 = new THREE.Mesh(geometry_tiles4, material_tiles4);
scene.add(toilettiles4);
toilettiles4.position.set(4, 3.4, -3.6)

// group.add(toilettiles4);

// ******************BackSideWashRoomWall*****************

const geometry_backSideWashroomWall = new THREE.BoxGeometry(9, 5, 0.4);
const material_backSideWashroomWall = new THREE.MeshPhongMaterial({ color: 0x003151 });
const cube_backSideWashroomWall = new THREE.Mesh(geometry_backSideWashroomWall, material_backSideWashroomWall);
scene.add(cube_backSideWashroomWall);
cube_backSideWashroomWall.position.x = -0.9;
cube_backSideWashroomWall.position.y = 3.4;
cube_backSideWashroomWall.position.z = -9;

// group.add(cube_backSideWashroomWall);

// ****************************kitchenUpper*********************

const geometry_kitchen = new THREE.BoxGeometry(18, 0.7, 0.4);
const material_kitchen = new THREE.MeshPhongMaterial({ color: 0x003151 });
const cube_kitchen = new THREE.Mesh(geometry_kitchen, material_kitchen);
scene.add(cube_kitchen);
cube_kitchen.position.x = 13;
cube_kitchen.position.y = 5.5;
cube_kitchen.position.z = -9;

// group.add(cube_kitchen);

// ***********************kitchenDoor************************

const geometry_kitchenDoor = new THREE.BoxGeometry(1.7, 5, 0.4);
const material_kitchenDoor = new THREE.MeshPhongMaterial({ color: 0x003151 });
// material_kitchenDoor.transparent = true;
const cube_kitchenDoor = new THREE.Mesh(geometry_kitchenDoor, material_kitchenDoor);
scene.add(cube_kitchenDoor);
cube_kitchenDoor.position.set(10, 3.4, -8.9)


// group.add(cube_kitchenDoor);

// **********************standingkitchen***********************

// const geometry_standingKitchenleftWall = new THREE.BoxGeometry(2.8, 2, 9);
// const material_standingKitchenleftWall = new THREE.MeshPhongMaterial({ color: 0xe9e0d4 });
// const cube_standingKitchenleftWall = new THREE.Mesh(geometry_standingKitchenleftWall, material_standingKitchenleftWall);
// scene.add(cube_standingKitchenleftWall);
// cube_standingKitchenleftWall.position.x = 10.5;
// cube_standingKitchenleftWall.position.y = 2.1;
// cube_standingKitchenleftWall.position.z = -4.3;

// group.add(cube_standingKitchenleftWall);

// ************************standingkitchentFronwall**********************

const geometry_standingkitchentRightWall = new THREE.BoxGeometry(2, 2, 9);
const material_standingkitchentRightWall = new THREE.MeshPhongMaterial({ color: 0xe9e0d4 });
const cube_standingkitchentFronwallRightWall = new THREE.Mesh(geometry_standingkitchentRightWall, material_standingkitchentRightWall);
scene.add(cube_standingkitchentFronwallRightWall);
cube_standingkitchentFronwallRightWall.position.x = 21.62;
cube_standingkitchentFronwallRightWall.position.y = 2.1;
cube_standingkitchentFronwallRightWall.position.z = -4.3;

// group.add(cube_standingkitchentFronwallRightWall);

// **************************standingkitchenfrontWall********************

const geometry_standingkitchentFronwall = new THREE.BoxGeometry(9, 2, 2.5);
const material_standingkitchentFronwall = new THREE.MeshPhongMaterial({ color: 0xe9e0d4 });
const cube_standingkitchentFronwall = new THREE.Mesh(geometry_standingkitchentFronwall, material_standingkitchentFronwall);
scene.add(cube_standingkitchentFronwall);
cube_standingkitchentFronwall.position.x = 16.3
cube_standingkitchentFronwall.position.y = 2.1;
cube_standingkitchentFronwall.position.z = -7.52;

// group.add(cube_standingkitchentFronwall);

// *************************kitcenUpperright2**************************

const geometry_kitchenUpperright2 = new THREE.BoxGeometry(0.4, 0.7, 11);
const material_kitchenUpperright2 = new THREE.MeshPhongMaterial({ color: 0x003151 });
const cube__kitchenUpperright2 = new THREE.Mesh(geometry_kitchenUpperright2, material_kitchenUpperright2);
scene.add(cube__kitchenUpperright2);
cube__kitchenUpperright2.position.x = 21.85;
cube__kitchenUpperright2.position.y = 5.5;
cube__kitchenUpperright2.position.z = -3.4;

// group.add(cube__kitchenUpperright2);

// **************************officewall*******************

const geometry_officewall = new THREE.BoxGeometry(12, 5, 0.4);
const material_officewall = new THREE.MeshPhongMaterial({ color: 0x003151 });
const cube_officewall = new THREE.Mesh(geometry_officewall, material_officewall);
scene.add(cube_officewall);
cube_officewall.position.set(16, 3.4, 2.3);


// group.add(cube_officewall);

// **************************officeBackwall******************

const geometry_officeBackwall = new THREE.BoxGeometry(7, 5, 0.4);
const material_officeBackwall = new THREE.MeshPhongMaterial({ color: 0x003151 });
const cube_officeBackwall = new THREE.Mesh(geometry_officeBackwall, material_officeBackwall);
scene.add(cube_officeBackwall);
cube_officeBackwall.position.x = 18.5;
cube_officeBackwall.position.y = 3.4;
cube_officeBackwall.position.z = 18;

// group.add(cube_officeBackwall);

// ********************************* bedRoomWall **********************

const geometry_bedRoom1 = new THREE.BoxGeometry(9.7, 5, 0.3);
const material_bedRoom1 = new THREE.MeshPhongMaterial({ color: 0x708090 });
const room_bedRoom1 = new THREE.Mesh(geometry_bedRoom1, material_bedRoom1);
scene.add(room_bedRoom1);
room_bedRoom1.position.set(-10.4, 3.4, 8);

// **************************** bedRoomWall2 **********

const geometry_leftSideWall3 = new THREE.BoxGeometry(0.35, 5, 7.5);
const material_leftSideWall3 = new THREE.MeshPhongMaterial({ color: 0x708090 });
const cube_leftSideWall3 = new THREE.Mesh(geometry_leftSideWall3, material_leftSideWall3);
scene.add(cube_leftSideWall3);
cube_leftSideWall3.position.set(-5.4, 3.4, 14.07)

// **************************officeLeftwall***************

const geometry_officeLeftwall = new THREE.BoxGeometry(0.1, 3.4, 5.9);
const material_officeLeftwall = new THREE.MeshPhongMaterial({ color: 0xff8090 });
const cube_officeLeftwall = new THREE.Mesh(geometry_officeLeftwall, material_officeLeftwall);
scene.add(cube_officeLeftwall);
cube_officeLeftwall.position.set(21.56, 3.4, 9.5);

// group.add(cube_officeLeftwall);

// *********************toilettiles*****************

const geometry_paiting = new THREE.BoxGeometry(9, 5, 0);
const material_panting = new THREE.MeshBasicMaterial({ map: loader.load('https://t4.ftcdn.net/jpg/01/29/36/83/360_F_129368372_Lolknh3EsxTC9Y6ehEfKvWD60FAOx6w8.jpg') }); //https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSM3PtgtmI6lxwYsCQ43kgw5fR0XIRnrjZxujUChxBDiK6p1Lr4ypmgWGqdk98cqBlvw3s&usqp=CAU
const cube_paiting = new THREE.Mesh(geometry_paiting, material_panting);
scene.add(cube_paiting);
cube_paiting.position.x = -0.7;
cube_paiting.position.y = 3.4;
cube_paiting.position.z = -8.76;

// group.add(cube_paiting);

// ************************toiletend****************

// *************************officeRifhtwall***********************

const geometry_officeRifhtwall = new THREE.BoxGeometry(0.4, 5, 15.4);
const material_officeRifhtwall = new THREE.MeshPhongMaterial({ color: 0x003151 });
const cube_officeRifhtwall = new THREE.Mesh(geometry_officeRifhtwall, material_officeRifhtwall);
scene.add(cube_officeRifhtwall);
cube_officeRifhtwall.position.x = 21.8;
cube_officeRifhtwall.position.y = 3.4;
cube_officeRifhtwall.position.z = 10.2;

// group.add(cube_officeRifhtwall);

// **************************kitchenFrontSideMirror******************

const geometry_frontDoorwall = new THREE.BoxGeometry(11.3, 2, 0.4);
const material_frontDoorwall = new THREE.MeshBasicMaterial({ color: 0xFFFFFF });
material_frontDoorwall.transparent = true;
material_frontDoorwall.opacity = 0.5;
const cube_frontDoorwall = new THREE.Mesh(geometry_frontDoorwall, material_frontDoorwall);
scene.add(cube_frontDoorwall);
cube_frontDoorwall.position.set(16.5, 4.1, -9);

// group.add(cube_frontDoorwall);

// ************************kitchenRifhtsideMirror*****************

const geometry_kitchenRifhtsideMirror = new THREE.BoxGeometry(0.4, 1.9, 9.9);
const material_kitchenRifhtsideMirror = new THREE.MeshBasicMaterial({ color: 0xFFFFFF });
material_kitchenRifhtsideMirror.transparent = true;
material_kitchenRifhtsideMirror.opacity = 0.5;
const cube_kitchenRifhtsideMirror = new THREE.Mesh(geometry_kitchenRifhtsideMirror, material_kitchenRifhtsideMirror);
scene.add(cube_kitchenRifhtsideMirror);
cube_kitchenRifhtsideMirror.position.x = 21.85;
cube_kitchenRifhtsideMirror.position.y = 4.2;
cube_kitchenRifhtsideMirror.position.z = -3.4;

// group.add(cube_kitchenRifhtsideMirror);

// *********************** gasSylinder ***************

const group1 = new THREE.Group();

const geometryGas = new THREE.BoxGeometry(3, 0.3, 1.5);
const materialGas = new THREE.MeshBasicMaterial({ color: 0x000000 });
const meshGas = new THREE.Mesh(geometryGas, materialGas);
scene.add(meshGas);
meshGas.position.set(10, 6, -6);

// meshGas.rotation.x = 0.2;

group1.add(meshGas);

const cylinderGeometryleg1 = new THREE.CylinderGeometry(0.2, 0.3, 0.5, 32);
const cylinderMaterialleg1 = new THREE.MeshBasicMaterial({ color: 0xffff00 });
const cylinderleg1 = new THREE.Mesh(cylinderGeometryleg1, cylinderMaterialleg1);
scene.add(cylinderleg1);

group1.add(cylinderleg1);

cylinderleg1.position.set(11, 5.6, -5.8);

const cylinderGeometry = new THREE.CylinderGeometry(0.2, 0.3, 0.5, 32);
const cylinderMaterial = new THREE.MeshBasicMaterial({ color: 0xffff00 });
const cylinder = new THREE.Mesh(cylinderGeometry, cylinderMaterial);
scene.add(cylinder);

group1.add(cylinder);

cylinder.position.set(9, 5.6, -5.8);

const cylinderGeometryleg2 = new THREE.CylinderGeometry(0.2, 0.3, 0.5, 32);
const cylinderMaterialleg2 = new THREE.MeshBasicMaterial({ color: 0xffff00 });
const cylinderleg2 = new THREE.Mesh(cylinderGeometryleg2, cylinderMaterialleg2);
scene.add(cylinderleg2);

group1.add(cylinderleg2);

cylinderleg2.position.set(11, 5.6, -6.5);

const cylinderGeometryleg3 = new THREE.CylinderGeometry(0.2, 0.3, 0.5, 32);
const cylinderMaterialleg3 = new THREE.MeshBasicMaterial({ color: 0xffff00 });
const cylinderleg3 = new THREE.Mesh(cylinderGeometryleg3, cylinderMaterialleg3);
scene.add(cylinderleg3);

group1.add(cylinderleg3);

cylinderleg3.position.set(9, 5.6, -6.5);

scene.add(group1);

const group5 = new THREE.Group();

const gas1Geometry = new THREE.BoxGeometry(0.6, 0.1, 0.05);
const gas1Material = new THREE.MeshBasicMaterial({ color: 0xffffff });
const gas1Mesh = new THREE.Mesh(gas1Geometry, gas1Material);
scene.add(gas1Mesh);

gas1Mesh.position.set(10.8, 6.20, -6.32);

group1.add(gas1Mesh);

group5.add(gas1Mesh)

const gas2Geometry = new THREE.BoxGeometry(0.6, 0.1, 0.05);
const gas2Material = new THREE.MeshBasicMaterial({ color: 0xffffff });
const gas2Mesh = new THREE.Mesh(gas2Geometry, gas2Material);
scene.add(gas2Mesh);

group1.add(gas2Mesh);

group5.add(gas2Mesh)

gas2Mesh.position.set(10.8, 6.20, -5.6);

const gas3Geometry = new THREE.BoxGeometry(0.05, 0.1, 0.8);
const gas3Material = new THREE.MeshBasicMaterial({ color: 0xffffff });
const gas3Mesh = new THREE.Mesh(gas3Geometry, gas3Material);
scene.add(gas3Mesh);

// gas3Mesh.rotation.x = 0.2;

gas3Mesh.position.set(11.08, 6.20, -5.95);

group1.add(gas3Mesh);
group5.add(gas3Mesh)

const gas4Geometry = new THREE.BoxGeometry(0.05, 0.1, 0.8);
const gas4Material = new THREE.MeshBasicMaterial({ color: 0xffffff });
const gas4Mesh = new THREE.Mesh(gas4Geometry, gas4Material);
scene.add(gas4Mesh);

gas4Mesh.position.set(10.5, 6.20, -5.95);

group1.add(gas4Mesh);

group5.add(gas4Mesh);



const gas5Geometry = new THREE.BoxGeometry(0.05, 0.1, 0.35);
const gas5Material = new THREE.MeshBasicMaterial({ color: 0xffffff });
const gas5Mesh = new THREE.Mesh(gas5Geometry, gas5Material);
scene.add(gas5Mesh);

gas5Mesh.rotation.y = 0.5;

gas5Mesh.position.set(10.58, 6.20, -6.19);

group1.add(gas5Mesh)
group5.add(gas5Mesh)

const gas6Geometry = new THREE.BoxGeometry(0.05, 0.1, 0.35);
const gas6Material = new THREE.MeshBasicMaterial({ color: 0xffffff });
const gas6Mesh = new THREE.Mesh(gas6Geometry, gas6Material);
scene.add(gas6Mesh);

gas6Mesh.rotation.y = -0.5;

gas6Mesh.position.set(11, 6.20, -6.19);

group1.add(gas6Mesh)

group5.add(gas6Mesh)

const gas7Geometry = new THREE.BoxGeometry(0.05, 0.1, 0.35);
const gas7Material = new THREE.MeshBasicMaterial({ color: 0xffffff });
const gas7Mesh = new THREE.Mesh(gas7Geometry, gas7Material);
scene.add(gas7Mesh);

gas7Mesh.rotation.y = -0.5;

gas7Mesh.position.set(10.58, 6.20, -5.8);

group1.add(gas7Mesh)

group5.add(gas7Mesh)

const gas8Geometry = new THREE.BoxGeometry(0.05, 0.1, 0.35);
const gas8Material = new THREE.MeshBasicMaterial({ color: 0xffffff });
const gas8Mesh = new THREE.Mesh(gas8Geometry, gas8Material);
scene.add(gas8Mesh);

gas8Mesh.rotation.y = 0.5;

gas8Mesh.position.set(11, 6.20, -5.8);

group1.add(gas8Mesh)
group5.add(gas8Mesh);

const cloneGroup5 = group5.clone();
scene.add(cloneGroup5);
// cloneGroup5.position.x = 4;

group1.add(cloneGroup5)

const newClone = cloneGroup5.clone();
scene.add(newClone);
newClone.position.x = -1.5;

group1.add(newClone)

group1.position.set(6, -3.46, -2.5);
group1.rotation.x = 0.2;

// ****************** end gasSylinder *************

// ***********************************3Dchair*********************

// *********************fortoilet************

const length = 0.1, width = 0.5;

const shape = new THREE.Shape();
shape.moveTo(0, 0);
// shape.bezierCurveTo(1);
shape.lineTo(0, width);
shape.lineTo(length, width);
shape.lineTo(length, 0);
shape.lineTo(0, 0);

const extrudeSettings = {
    steps: 2,
    depth: 1,
    bevelEnabled: true,
    bevelThickness: 1,
    bevelSize: 1,
    bevelOffset: 0,
    bevelSegments: 10
};

const geometry_toilate = new THREE.ExtrudeGeometry(shape, extrudeSettings);
const material_toilate = new THREE.MeshPhongMaterial({ color: 0xffffff });
const mesh_toilate = new THREE.Mesh(geometry_toilate, material_toilate);
scene.add(mesh_toilate);

// group.add(mesh_toilate);

mesh_toilate.position.y = 1.6;
mesh_toilate.position.z = -8;
mesh_toilate.position.x = 1.5;
// mesh_toilate.rotation.y = -5;

// *************************BED*******************

const length_sofa = 5, width_sofa = 0.1;

const shape_sofa = new THREE.Shape();
shape_sofa.moveTo(0, 0);
// shape.bezierCurveTo(1);
shape_sofa.lineTo(0, width_sofa);
shape_sofa.lineTo(length_sofa, width_sofa);
shape_sofa.lineTo(length_sofa, 0);
shape_sofa.lineTo(0, 0);

const extrudeSettings_sofa = {
    steps: 2,
    depth: 6,
    bevelEnabled: true,
    bevelThickness: 1,
    bevelSize: 1,
    bevelOffset: 0,
    bevelSegments: 10
};

const geometry_sofa = new THREE.ExtrudeGeometry(shape_sofa, extrudeSettings_sofa);
const material_sofa = new THREE.MeshPhongMaterial({ color: 0x708090 });
const mesh_sofa = new THREE.Mesh(geometry_sofa, material_sofa);
scene.add(mesh_sofa);


// group.add(mesh_sofa);

// mesh_sofa.userData.draggable = true;
// mesh_sofa.userData.name = 'MESH_SOFA';

mesh_sofa.position.set(-14.3, 1.9, 3);

mesh_sofa.rotation.y = 1.6;

// ************************************ 3d object loader ***********************

const loaderr = new GLTFLoader(loadingManager);

loaderr.load(

    diningUrl.href,
    function (newBed) {

        const dining = newBed.scene.children[0];
        console.log(dining)
        dining.scale.set(4, 4, 4)
        scene.add(dining);


        // bed.position.y = 10

        dining.position.set(3, 3.5, 10);

        dining.userData.draggable = true;

        // bed.scale.set(5,5,5);
    }
)

loaderr.load(
    tableurl.href,

    function (object) {

        var materialColor = new THREE.MeshPhongMaterial({ color: 0x804c36 });

        const table = object.scene.children[0];
        scene.add(table);
        table.scale.set(0.04, 0.04, 0.04);
        table.position.set(-10.5, 1, 15.94);

        table.traverse(function (child) {
            if (child instanceof THREE.Mesh) {
                child.material = materialColor;
            }
        })
    }
)

loaderr.load(
    sofaUrl1.href,
    function (object) {
        const sofa = object.scene.children[0];
        scene.add(sofa);

        console.log(sofa);

        sofa.rotation.z = 1.57;

        sofa.position.set(10, 1, 10)

        sofa.scale.set(0.07, 0.07, 0.07);

    }
)





// **************************** garden ************************

// loaderr.load(

//     newGarden.href,
//     function (object) {
//         const garden = object.scene.children[0];

//         scene.add(garden);

//         // group.add(garden);

//         // garden.position.y = 0;
//         // garden.position.z = 17;
//         garden.rotation.z = 3.15;
//         garden.position.set(0,0.8,17)
//         garden.scale.set(0.05, 0.05, 0.05);

//         garden.userData.draggable = true;
//         // garden.userData.name = 'Sketchfab_model';

//     });

// *********************** endgarden ********************
// *****************television************************

const geometry_television = new THREE.BoxGeometry(0.35, 2, 5);
const material_television = new THREE.MeshPhongMaterial({ color: 0x1c1c1c });
const cube_television = new THREE.Mesh(geometry_television, material_television);
scene.add(cube_television);
cube_television.position.x = -5.6;
cube_television.position.y = 4;
cube_television.position.z = -0.5;

cube_television.addEventListener('click', function (event) {
    console.log('Mesh was clicked!', event);
});
// create the galaxy

const parameters = {}
parameters.count = 651800;
parameters.size = 0.01;
parameters.radius = 3;
parameters.branches = 3;
parameters.spin = 1;
parameters.randomness = 0.2;
parameters.randomnessPower = 8;
parameters.insideColor = '#ff6030';
parameters.outsideColor = '#1b3984';

let geometry = null
let material = null
let points = null

function generateGalaxy() {

    /**
    * Destroy old galaxy
    */

    if (points != null) {
        geometry.dispose();
        material.dispose();
        scene.remove(points);
    }

    geometry = new THREE.BufferGeometry();

    const positions = new Float32Array(parameters.count * 3);
    const colors = new Float32Array(parameters.count * 3);

    const colorInside = new THREE.Color(parameters.insideColor);
    const colorOutside = new THREE.Color(parameters.outsideColor);

    for (let i = 0; i < parameters.count; i++) {
        const i3 = i * 3;

        // position
        const radius = Math.random() * parameters.radius
        const spinAngle = radius * parameters.spin
        const branchAngle = (i % parameters.branches) / parameters.branches * Math.PI * 2

        const randomX = Math.pow(Math.random(), parameters.randomnessPower) * (Math.random() < 0.5 ? 1 : -1)
        const randomY = Math.pow(Math.random(), parameters.randomnessPower) * (Math.random() < 0.5 ? 1 : -1)
        const randomZ = Math.pow(Math.random(), parameters.randomnessPower) * (Math.random() < 0.5 ? 1 : -1)

        if (i < 20) {
            // console.log(i , branchAngle);
        }

        positions[i3] = Math.cos(branchAngle + spinAngle) * radius + randomX;
        positions[i3 + 1] = randomY;
        positions[i3 + 2] = Math.sin(branchAngle + spinAngle) * radius + randomZ;

        // color

        const mixedColor = colorInside.clone();
        mixedColor.lerp(colorOutside, radius / parameters.radius)

        colors[i3] = mixedColor.r;
        colors[i3 + 1] = mixedColor.g;
        colors[i3 + 2] = mixedColor.b;

    }

    geometry.setAttribute(
        'position',
        new THREE.BufferAttribute(positions, 3)
    )

    geometry.setAttribute(
        'color',
        new THREE.BufferAttribute(colors, 3)
    )

    material = new THREE.PointsMaterial({
        size: parameters.size,
        sizeAttenuation: true,
        depthWrite: false,
        blending: THREE.AdditiveBlending,
        vertexColors: true
    })

    points = new THREE.Points(geometry, material);
    // scene.add(points);



    points.position.set(8, 2.8, 8);

    points.rotation.x = 1.6;

    points.scale.z = 0.3;
    points.scale.y = 0.3;
    points.scale.x = 0.3;

    function animate1() {
        requestAnimationFrame(animate1);
        points.rotation.y += 0.01;
    }
    animate1();

}

generateGalaxy();

// create galaxyEnd
const clickMouse1 = new THREE.Vector2(0, 0);
const raycaster1 = new THREE.Raycaster();
var draggable1 = new THREE.Object3D();

var material1 = new THREE.MeshPhongMaterial({ color: 0xff00ff });
let mixer;
loaderr.load(
    doorUrl.href,
    function (object) {

        const door = object.scene.children[0];



        scene.add(door);


        // door.castShadow = true;

        // group.add(castle);

        mixer = new THREE.AnimationMixer(door);
        const clips = object.animations;

        function ronak() {
            clips.forEach(function (clip) {
                const action = mixer.clipAction(clip);
                action.play();
            })

            setTimeout(() => {
                mixer.stopAllAction();
            }, 2200);
        }

        // const controls = new DragControls([door], camera, renderer.domElement);

        // controls.addEventListener('dragstart',  () => {
        //     controls.getRaycaster(true);
        //     // controls.dispose();

        //     // controls.deactivate();

        //     orbit.enabled = false;
        //     ronak();

        //     door.position.set(-3.5, 3.5, 2);
        // });


        // controls.addEventListener('dragend', () => {

        //     orbit.enabled = true;
        // });

        door.userData.draggable1 = true;

        const selectedObjects1 = [];

        window.addEventListener('click', event => {

            clickMouse1.x = (event.clientX / window.innerWidth) * 2 - 1;
            clickMouse1.y = - (event.clientY / window.innerHeight) * 2 + 1;

            raycaster1.setFromCamera(clickMouse1, camera);

            const found = raycaster1.intersectObjects(scene.children, true);

            // selectedObjects.length = 0;

            if (found.length > 0 && found[0].object.userData.draggable1) {

                // draggable = found[0].object;

                const selected = found[0].object;

                selectedObjects1.push(selected);

                ronak();

                // console.log("found draggable ", draggable.userData.name);

            }

        })

        // Set the desired animation speed
        const animationSpeed = 0.5;

        // Set the time scale to adjust the animation speed
        mixer.timeScale = animationSpeed;

        door.position.z = 1.8; // 2
        door.position.y = 3.5;
        door.position.x = -3.62; // 3.5
        // door.rotation.y = 4.76;

        door.rotation.z = 3.13;

        door.scale.z = 2.5;
        door.scale.x = 1.62;

        // door.userData.draggable = true;

        door.traverse(function (child) {
            if (child instanceof THREE.Mesh) {
                child.material = material1;
            }
        })

    });

var video = document.getElementById("video");

var tvOn = document.getElementById("tvOn");
tvOn.addEventListener("click", TV);

function TV() {
    // video.onloadeddata = function () {
    video.play();
    // };
}



//Create your video texture:
const videoTexture = new THREE.VideoTexture(video);
videoTexture.needsUpdate = true;
const videoMaterial = new THREE.MeshBasicMaterial({
    map: videoTexture,
    side: THREE.FrontSide,
    toneMapped: false,
});

//Create screen
const screen = new THREE.BoxGeometry(0.1, 3.2, 5.5);

//0.4, 5, 7.5
const videoScreen = new THREE.Mesh(screen, videoMaterial);
scene.add(videoScreen);
// group.add(videoScreen);
videoScreen.position.set(21.45, 3.45, 9.5) // 21.56 ,3.4 ,8

function loadModel(positionX) {
    loaderr.load(plantUrl.href,
        function (gltf) {
            const plant = gltf.scene;
            plant.position.set(positionX, 0.8, 20);
            scene.add(plant);
            // console.log(plant);
            plant.scale.set(0.6, 0.6, 0.6);
        });
}

var positions = [0, 3, 6];

for (var i = 0; i < positions.length; i++) {
    loadModel(positions[i]);
}

// loaderr.load(
//     plantUrl.href,
//     function (object){

//         const plant = object.scene.children[0];
//         scene.add(plant);
//         plant.position.set(0,0.8,22);

//     }
// )



// ****************************** chairUrl *****************************

// var buttons = document.getElementById("fire");
// buttons.addEventListener("click", onButtonClick);

// function onButtonClick() {

//     var material = new THREE.MeshPhongMaterial({ color: 0xff00ff });

//     loaderr.load(
//         chairUrl.href,
//         function (object) {

//             const castle = object.scene.children[0];

//             scene.add(castle);
//             // group.add(castle);

//             castle.position.z = 7;
//             castle.position.y = 2.4;
//             castle.rotation.y = 4.76;

//             // castle.scale.set(1,0.2,1);

//             castle.userData.draggable = true;


//             castle.traverse(function (child) {
//                 if (child instanceof THREE.Mesh) {
//                     child.material = material;
//                 }
//             })
//             console.log(castle);
//         },

//         function (xhr) {
//             // Callback function for when the object is still loading
//             console.log((xhr.loaded / xhr.total * 100) + '% loaded');
//         },
//         function (error) {
//             // Callback function for when there's an error loading the object
//             console.error('Error loading .obj file:', error);
//         }
//     );
// }

// **************************** endChair ****************************

camera.position.z = 16;
// camera.position.x = 4;
camera.position.y = 4; // 23
camera.position.x = 5;
// scene.add(camera);

const raycaster = new THREE.Raycaster();
const clickMouse = new THREE.Vector2(0, 0);
const moveMouse = new THREE.Vector3();
var draggable = new THREE.Object3D();

// ******************** simpleBoxgeometry ***********

// *********************** simpleBoxgeometryend ********************

const selectedObjects = [];

// addMatrixPhysics.userData.draggable = true;

window.addEventListener('click', event => {

    clickMouse.x = (event.clientX / window.innerWidth) * 2 - 1;
    clickMouse.y = - (event.clientY / window.innerHeight) * 2 + 1;

    raycaster.setFromCamera(clickMouse, camera);

    const found = raycaster.intersectObjects(scene.children, true);

    // selectedObjects.length = 0;


    if (found.length > 0 && found[0].object.userData.draggable) {

        // draggable = found[0].object;

        const selected = found[0].object;

        selectedObjects.push(selected);

        orbit.enabled = false;



        console.log("ronak");

        // console.log("found draggable ", draggable.userData.name);

    }
})

window.addEventListener('dblclick', event => {

    orbit.enabled = true;

    clickMouse.x = (event.clientX / window.innerWidth) * 2 - 1;
    clickMouse.y = - (event.clientY / window.innerHeight) * 2 + 1;

    selectedObjects.length = 0;
})

window.addEventListener('mousemove', event => {

    moveMouse.x = (event.clientX / window.innerWidth) * 2 - 1;
    moveMouse.y = - (event.clientY / window.innerHeight) * 2 + 1;

})

function dragObject() {
    if (draggable != null) {

        raycaster.setFromCamera(moveMouse, camera);
        let found = raycaster.intersectObjects(scene.children)
        if (selectedObjects.length > 0) {
            if (found.length > 0) {
                for (let o of found) {
                    if (!o.object.userData.ground)
                        continue

                    selectedObjects[0].position.x = o.point.x;
                    selectedObjects[0].position.z = o.point.z;

                }
            }
        }
    }
}

// ***************************** end the rotation *****************

// ******************************* start realistic glass *************

// ************************** end realistic glass **********

import nagativex from '../public/nx.png';
import nagativey from '../public/ny.png';
import nagativez from '../public/nz.png';
import positivex from '../public/px.png';
import positivey from '../public/py.png';
import positivez from '../public/pz.png';

import { fragmentShader } from '../public/shaders/test/fragment.js';
import { vertex } from '../public/shaders/test/vertex.js';
import { testFragmentShader } from '../public/shaders/test/fragment1.js';
import { testVertexShader } from '../public/shaders/test/vertex1.js';

const cubeTextureLoader = new THREE.CubeTextureLoader(loadingManager);

scene.background = cubeTextureLoader.load([
    positivex,
    nagativex,
    positivey,
    nagativey,
    positivez,
    nagativez
]);

renderer.shadowMap.enabled = true;

const clock = new THREE.Clock();

const clock2 = new THREE.Clock();

// ************************** start ***********

// renderer.domElement.addEventListener('dblclick', onMouseClick , false);

// function onMouseClick(event) {
//     // Update the target zoom level
//     targetZoom += 0.5;

//     // Limit the zoom level
//     if (targetZoom > 3) {
//       targetZoom = 1;
//     }
//   }

// ************************ end *****************


function animate() {
    // requestAnimationFrame( animate );

    world.step(timeStep);

    // Update the camera zoom
    // currentZoom += (targetZoom - currentZoom) * zoomSpeed;
    // camera.fov = 75 / currentZoom;
    // camera.updateProjectionMatrix();

    if (sceneReady) {
        for (const point of newPoints) {
            const screenPosition = point.position.clone()
            screenPosition.project(camera)

            raycaster.setFromCamera(screenPosition, camera)
            const intersects = raycaster.intersectObjects(scene.children, true)

            if (intersects.length === 0) {
                point.element.classList.add('visible')
            }
            else {
                const intersectionDistance = intersects[0].distance;
                const pointDistance = point.position.distanceTo(camera.position)

                if (intersectionDistance < pointDistance) {
                    point.element.classList.remove('visible')
                }
                else {
                    point.element.classList.add('visible')
                }

                // console.log(intersectionDistance)
            }

            const translateX = screenPosition.x * sizes.width * 0.5
            const translateY = - screenPosition.y * sizes.height * 0.5
            point.element.style.transform = `translate(${translateX}px, ${translateY}px)`

        }
    }

    const exclipsTime = clock2.getElapsedTime();
    materialShaders.uniforms.uTime.value = exclipsTime * 3



    cube_FirstFlore.position.copy(groundBody.position);
    cube_FirstFlore.quaternion.copy(groundBody.quaternion);

    cube_leftSideWall2.position.copy(cube_leftSideWall2physics.position);
    cube_leftSideWall2.quaternion.copy(cube_leftSideWall2physics.quaternion);

    if (Math.random() > 0.93 || flash.power > 100) {
        if (flash.power < 100)
            flash.position.set(
                Math.random() * 400,
                300 + Math.random() * 200,
                100
            );
        flash.power = 50 + Math.random() * 500;
    }

    dragObject();

    orbit.update();

    if (mixer)
        mixer.update(clock.getDelta());

    if (Movements.isPressed(37)) { // left key
        camera.position.x -= 0.5;
        // camera.position.z -=0.5;
    }

    if (Movements.isPressed(38)) { // up key
        camera.position.x += 0.5;

        camera.position.y += 0.5;
        // camera.rotation.x += 5;
    }

    if (Movements.isPressed(39)) { // right key
        camera.position.x += 0.5;
    }

    if (Movements.isPressed(40)) { // down key
        camera.position.x -= 0.5;
        camera.position.y -= 0.5;
    }

    if (Movements.isPressed(87)) { //  W key

    }

    if (Movements.isPressed(83)) { // s key

    }

    if (Movements.isPressed(65)) { // a key

    }

    if (Movements.isPressed(68)) { // d key

    }

    camera.lookAt(scene.position);

    renderer.render(scene, camera);

}

renderer.setAnimationLoop(animate);

// animate()

window.addEventListener('resize', function () {

    camera.aspect = window.innerWidth / window.innerHeight;
    camera.updateProjectionMatrix();
    renderer.setSize(window.innerWidth, this.window.innerHeight);

})